import React, { useEffect, useState } from 'react';
import TrendingListingsContext from './TrendingListings.context';
import utils from 'utils';
import useSiteInitializedState from 'hooks/useSiteInitializedState';
import { LISTING_TIERS, TrendingListing } from 'models/Listing';
import api from 'api';
import { FIRST_PAGE } from 'data/global';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

const TrendingListings: React.FC = (props) => {
  const { children } = props;

  const [loading, setLoading] = useState(utils.isSSGHuman());

  const [trendings, setTrendings] =
    useSiteInitializedState<Array<TrendingListing>>('trendings-array');

  const getMixpanelProps = useGetMixpanelProps();

  useEffect(() => {
    !utils.isSSGHuman() &&
      (async () => {
        try {
          setLoading(true);

          const {
            data: { items },
          } = await api.listings.getListings({
            page: FIRST_PAGE,
            limit: '25',
            tier: { $ne: LISTING_TIERS.PLATINUM },
          });

          setTrendings(items);
        } catch (e) {
          mixpanelService.errorViewed(
            getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
          );
        } finally {
          setLoading(false);
        }
      })();
  }, [getMixpanelProps, setTrendings]);

  return (
    <TrendingListingsContext.Provider value={{ loading, trendings }}>
      {children}
    </TrendingListingsContext.Provider>
  );
};

export default TrendingListings;
